import { SelectOption } from '../../../sharedModules/form/model';
import { WarehouseOption } from '../../warehouseOptions/model';

export const toNameChoices = (names: string[] = []): SelectOption[] =>
  names.map((name) => ({ label: name, value: name }));

export const toWarehouseChoices = (warehouses: WarehouseOption[]): SelectOption[] =>
  warehouses.map((warehouse) => ({ label: warehouse.name, value: warehouse.wh_id }));

export const buildReceivingLogFilters = (
  receiverChoices: SelectOption[],
  warehouseChoices: SelectOption[],
  departmentChoices: SelectOption[],
) => [
  { label: 'PO', type: 'text', param: 'po_no_eq' },
  { label: 'Order #', type: 'text', param: 'order_no_eq' },
  { label: 'Vendor', type: 'text', param: 'vendor_name_cont' },
  { label: 'Rack', type: 'text', param: 'rack_eq' },
  { label: 'Shelf', type: 'text', param: 'shelf_eq' },
  { label: 'Bin', type: 'text', param: 'bin_eq' },
  { label: 'Received by', type: 'select', param: 'received_by_name_eq', choices: receiverChoices },
  {
    label: 'PO progress',
    type: 'select',
    param: 'fully_received_eq',
    choices: [
      { label: 'Partially received', value: 'false' },
      { label: 'Fully received', value: 'true' },
    ],
  },
  { label: 'Warehouse', type: 'select', param: 'to_wh_eq', choices: warehouseChoices },
  { label: 'Department', type: 'select', param: 'department_name_eq', choices: departmentChoices },
];
